import React, { createContext, useContext, useReducer, useEffect } from "react";

const initialState = {
  cartItems: [],
  total: 0,
  isDrawerOpen: false, // 🔹 état du drawer
};

function calcTotal(items) {
  return items.reduce((sum, item) => {
    const price = Number(item.price) || 0;
    const quantity = Number(item.quantity) || 0;
    return sum + price * quantity;
  }, 0);
}

function cartReducer(state, action) {
  switch (action.type) {
    case "ADD_TO_CART": {
      const itemExist = state.cartItems.find(
        (item) => item._id === action.payload._id
      );

      let updatedCart;

      if (itemExist) {
        const newQuantity = itemExist.quantity + action.payload.quantity;

        if (newQuantity > action.payload.quantite) {
          return state; // on bloque si > stock
        }

        updatedCart = state.cartItems.map((item) =>
          item._id === action.payload._id
            ? { ...item, quantity: newQuantity }
            : item
        );
      } else {
        if (action.payload.quantity > action.payload.quantite) {
          return state; // idem si > stock
        }
        updatedCart = [...state.cartItems, action.payload];
      }

      return {
        ...state,
        cartItems: updatedCart,
        total: calcTotal(updatedCart),
        isDrawerOpen: true, // 🔹 ouvre le drawer après ajout
      };
    }

    case "UPDATE_QUANTITY": {
      const { _id, quantity } = action.payload;
      const productInCart = state.cartItems.find((item) => item._id === _id);
      if (!productInCart) return state;

      if (quantity > productInCart.quantite) return state;

      if (quantity <= 0) {
        const updatedCart = state.cartItems.filter((item) => item._id !== _id);
        return {
          ...state,
          cartItems: updatedCart,
          total: calcTotal(updatedCart),
        };
      }

      const updatedCart = state.cartItems.map((item) =>
        item._id === _id ? { ...item, quantity } : item
      );

      return {
        ...state,
        cartItems: updatedCart,
        total: calcTotal(updatedCart),
      };
    }

    case "REMOVE_FROM_CART": {
      const updatedCart = state.cartItems.filter(
        (item) => item._id !== action.payload
      );
      return {
        ...state,
        cartItems: updatedCart,
        total: calcTotal(updatedCart),
      };
    }

    case "CLEAR_CART":
      return { ...initialState };

    case "OPEN_DRAWER":
      return { ...state, isDrawerOpen: true };

    case "CLOSE_DRAWER":
      return { ...state, isDrawerOpen: false };

    default:
      return state;
  }
}

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const initializer = () => {
    try {
      const stored = JSON.parse(localStorage.getItem("cart"));
      return stored || initialState;
    } catch {
      return initialState;
    }
  };

  const [state, dispatch] = useReducer(cartReducer, undefined, initializer);

  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(state));
  }, [state]);

  const addToCart = (product) =>
    dispatch({ type: "ADD_TO_CART", payload: product });
  const removeFromCart = (id) =>
    dispatch({ type: "REMOVE_FROM_CART", payload: id });
  const updateQuantity = (_id, quantity) =>
    dispatch({ type: "UPDATE_QUANTITY", payload: { _id, quantity } });
  const clearCart = () => dispatch({ type: "CLEAR_CART" });
  const openDrawer = () => dispatch({ type: "OPEN_DRAWER" });
  const closeDrawer = () => dispatch({ type: "CLOSE_DRAWER" });

  return (
    <CartContext.Provider
      value={{
        ...state,
        addToCart,
        removeFromCart,
        updateQuantity,
        clearCart,
        openDrawer,
        closeDrawer,
      }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
